import { ElementRef, EventEmitter } from '@angular/core';
import { DropdownHelperService } from 'Angular/services/dropdown-helper.service';
import * as i0 from "@angular/core";
import * as i1 from "Angular/services/dropdown-helper.service";
import * as i2 from "@angular/common";
import * as i3 from "@angular/forms";
import * as i4 from "../../../../../../../../../ycharts/static/ts/features/components/modals/help-modal/components/help-modal.component";
import * as i5 from "../../../../../../../../../ycharts/static/ts/features/components/dropdowns/multi-select-dropdown/multi-select-dropdown.component";
import * as i6 from "../../../../../../../../../ycharts/static/ts/features/components/dropdowns/single-select-dropdown/single-select-dropdown.component";
const _c0 = ["chartOptions"];
const _c1 = a0 => ({ show: a0 });
const _c2 = () => ({ dropdownContainer: "dropdown-nested", button: "dropdown-item", dropdownItem: "pl-40" });
const _c3 = a0 => ({ "custom-checkbox-tall": a0 });
const _forTrack0 = ($index, $item) => $item.value;
function ChartOptionsComponent_For_8_Conditional_5_Template(rf, ctx) { if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1, "\u00A0");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(2, "span", 13);
    i0.ɵɵlistener("click", function ChartOptionsComponent_For_8_Conditional_5_Template_span_click_2_listener() { i0.ɵɵrestoreView(_r5); const listItem_r3 = i0.ɵɵnextContext().$implicit; i0.ɵɵnextContext(); const helpModal_r6 = i0.ɵɵreference(16); helpModal_r6.openModal(listItem_r3.helpName); return i0.ɵɵresetView(false); });
    i0.ɵɵtext(3, "(?)");
    i0.ɵɵelementEnd();
} }
function ChartOptionsComponent_For_8_Template(rf, ctx) { if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div")(1, "label", 9)(2, "input", 10);
    i0.ɵɵlistener("change", function ChartOptionsComponent_For_8_Template_input_change_2_listener() { const listItem_r3 = i0.ɵɵrestoreView(_r2).$implicit; const ctx_r3 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r3.updateChartOptions(listItem_r3)); });
    i0.ɵɵtwoWayListener("ngModelChange", function ChartOptionsComponent_For_8_Template_input_ngModelChange_2_listener($event) { const listItem_r3 = i0.ɵɵrestoreView(_r2).$implicit; i0.ɵɵtwoWayBindingSet(listItem_r3.selected, $event) || (listItem_r3.selected = $event); return i0.ɵɵresetView($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(3, "span", 11)(4, "span", 12);
    i0.ɵɵconditionalCreate(5, ChartOptionsComponent_For_8_Conditional_5_Template, 4, 0);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const listItem_r3 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(4, _c3, listItem_r3.description));
    i0.ɵɵadvance();
    i0.ɵɵtwoWayProperty("ngModel", listItem_r3.selected);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("textContent", listItem_r3.label);
    i0.ɵɵadvance();
    i0.ɵɵconditional(listItem_r3.helpName ? 5 : -1);
} }
function ChartOptionsComponent_Conditional_10_Template(rf, ctx) { if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ycn-multi-select-dropdown", 14);
    i0.ɵɵlistener("changeHandler", function ChartOptionsComponent_Conditional_10_Template_ycn_multi_select_dropdown_changeHandler_0_listener($event) { i0.ɵɵrestoreView(_r7); const ctx_r3 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r3.updateChartOptions($event)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵproperty("dropdownContainerClass", "dropdown-nested")("buttonClass", "dropdown-item")("dropdownItemClass", "pl-40")("config", ctx_r3.dataInFooterDropdownConfig);
} }
function ChartOptionsComponent_Conditional_11_Template(rf, ctx) { if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ycn-single-select-dropdown", 8);
    i0.ɵɵlistener("changeHandler", function ChartOptionsComponent_Conditional_11_Template_ycn_single_select_dropdown_changeHandler_0_listener($event) { i0.ɵɵrestoreView(_r8); const ctx_r3 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r3.updateChartDataInLegend($event)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵproperty("customCssClasses", i0.ɵɵpureFunction0(3, _c2))("customLabel", "Data in Legend")("config", ctx_r3.dataInLegendDropdownConfig);
} }
function ChartOptionsComponent_Conditional_13_Template(rf, ctx) { if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ycn-single-select-dropdown", 8);
    i0.ɵɵlistener("changeHandler", function ChartOptionsComponent_Conditional_13_Template_ycn_single_select_dropdown_changeHandler_0_listener($event) { i0.ɵɵrestoreView(_r9); const ctx_r3 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r3.updateChartValueFlags($event)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵproperty("customCssClasses", i0.ɵɵpureFunction0(3, _c2))("customLabel", "Value Flags")("config", ctx_r3.valueFlagsDropdownConfig);
} }
function ChartOptionsComponent_Conditional_14_Template(rf, ctx) { if (rf & 1) {
    const _r10 = i0.ɵɵgetCurrentView();
    i0.ɵɵelement(0, "div", 5);
    i0.ɵɵelementStart(1, "ycn-single-select-dropdown", 8);
    i0.ɵɵlistener("changeHandler", function ChartOptionsComponent_Conditional_14_Template_ycn_single_select_dropdown_changeHandler_1_listener($event) { i0.ɵɵrestoreView(_r10); const ctx_r3 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r3.updateChartFrequency($event)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("customCssClasses", i0.ɵɵpureFunction0(3, _c2))("customLabel", "Period")("config", ctx_r3.frequencyOptionsConfig);
} }
/**
 * Chart Options Component
 *
 * This component shows a list of chart options and checkboxes in dropdown. The checkboxes show whether
 * the corresponding item is currently selected. Below that, there is a nested single-select dropdown
 *  with options for how the name is displayed in the legend.
 *
 * Input Properties:
 *      chartOptionsConfig: Config for the main chart options dropdown
 *      nameInLegendOptionsConfig: Config for the nested "name in legend" options dropdown
 *      dataInLegendDropdownConfig: Config for the nested "data in legend" options dropdown
 *      frequencyOptionsConfig: Config for the nested "frequency" options dropdown
 *
 * Output Properties:
 *      closeHandler: EventEmitter that emits whenever the dropdown is closed
 *      chartOptionChangeHandler: EventEmitter that emits whenever a chart option is selected/deselected
 *      dataInLegendChangeHandler: emits when the selected "data in legend" option is changed
 *      nameInLegendChangeHandler: EventEmitter that emits whenever a "name in legend" option is changed
 *      frequencyChangeHandler: EventEmitter that emits whenever a "frequency" option is changed
 *
 * Internal Properties:
 *      isOpen: boolean for whether the dropdown is displaying the selectable items
 */
export class ChartOptionsComponent {
    constructor(dropdownHelperService) {
        this.dropdownHelperService = dropdownHelperService;
        this.chartOptionChangeHandler = new EventEmitter();
        this.nameInLegendChangeHandler = new EventEmitter();
        this.dataInLegendChangeHandler = new EventEmitter();
        this.valueFlagsChangeHandler = new EventEmitter();
        this.frequencyChangeHandler = new EventEmitter();
        this.closeHandler = new EventEmitter();
        this.isOpen = false;
    }
    ngAfterViewInit() {
        const autoCloseHandler = () => {
            if (this.isOpen) {
                this.toggle();
            }
        };
        this.dropdownHelperService.setCloseHandler(this.el.nativeElement, autoCloseHandler);
    }
    toggle() {
        if (this.isOpen) {
            this.isOpen = false;
            this.closeHandler.emit();
        }
        else {
            this.isOpen = true;
        }
    }
    updateChartOptions(newOption) {
        this.chartOptionChangeHandler.emit(newOption);
    }
    updateChartNameInLegend(newOption) {
        this.nameInLegendChangeHandler.emit(newOption);
    }
    updateChartFrequency(newOption) {
        this.frequencyChangeHandler.emit(newOption);
    }
    updateChartDataInLegend(newOption) {
        this.dataInLegendChangeHandler.emit(newOption);
    }
    updateChartValueFlags(newOption) {
        this.valueFlagsChangeHandler.emit(newOption);
    }
}
ChartOptionsComponent.ɵfac = function ChartOptionsComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || ChartOptionsComponent)(i0.ɵɵdirectiveInject(i1.DropdownHelperService)); };
ChartOptionsComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ChartOptionsComponent, selectors: [["ycn-chart-options"]], viewQuery: function ChartOptionsComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.el = _t.first);
    } }, inputs: { chartOptionsConfig: "chartOptionsConfig", nameInLegendOptionsConfig: "nameInLegendOptionsConfig", dataInFooterDropdownConfig: "dataInFooterDropdownConfig", dataInLegendDropdownConfig: "dataInLegendDropdownConfig", valueFlagsDropdownConfig: "valueFlagsDropdownConfig", frequencyOptionsConfig: "frequencyOptionsConfig" }, outputs: { chartOptionChangeHandler: "chartOptionChangeHandler", nameInLegendChangeHandler: "nameInLegendChangeHandler", dataInLegendChangeHandler: "dataInLegendChangeHandler", valueFlagsChangeHandler: "valueFlagsChangeHandler", frequencyChangeHandler: "frequencyChangeHandler", closeHandler: "closeHandler" }, standalone: false, decls: 17, vars: 15, consts: [["chartOptions", ""], ["helpModal", ""], [1, "dropdown", 3, "ngClass"], [1, "btn", "btn-secondary", "btn-block", "dropdown-toggle", "user-select-none", 3, "click"], [1, "dropdown-menu", 3, "ngClass"], [1, "dropdown-divider"], [3, "dropdownContainerClass", "buttonClass", "dropdownItemClass", "config"], [3, "customCssClasses", "customLabel", "config"], [3, "changeHandler", "customCssClasses", "customLabel", "config"], [1, "custom-control", "custom-checkbox", "dropdown-item", 3, "ngClass"], ["type", "checkbox", 1, "custom-control-input", 3, "change", "ngModelChange", "ngModel"], [1, "custom-control-indicator"], [1, "custom-control-description", 3, "textContent"], [1, "help-toggler", 3, "click"], [3, "changeHandler", "dropdownContainerClass", "buttonClass", "dropdownItemClass", "config"]], template: function ChartOptionsComponent_Template(rf, ctx) { if (rf & 1) {
        const _r1 = i0.ɵɵgetCurrentView();
        i0.ɵɵelementStart(0, "div", 2, 0)(2, "a", 3);
        i0.ɵɵlistener("click", function ChartOptionsComponent_Template_a_click_2_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.toggle()); });
        i0.ɵɵelementStart(3, "span")(4, "span");
        i0.ɵɵtext(5);
        i0.ɵɵelementEnd()()();
        i0.ɵɵelementStart(6, "div", 4);
        i0.ɵɵrepeaterCreate(7, ChartOptionsComponent_For_8_Template, 6, 6, "div", null, _forTrack0);
        i0.ɵɵelement(9, "div", 5);
        i0.ɵɵconditionalCreate(10, ChartOptionsComponent_Conditional_10_Template, 1, 4, "ycn-multi-select-dropdown", 6);
        i0.ɵɵconditionalCreate(11, ChartOptionsComponent_Conditional_11_Template, 1, 4, "ycn-single-select-dropdown", 7);
        i0.ɵɵelementStart(12, "ycn-single-select-dropdown", 8);
        i0.ɵɵlistener("changeHandler", function ChartOptionsComponent_Template_ycn_single_select_dropdown_changeHandler_12_listener($event) { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.updateChartNameInLegend($event)); });
        i0.ɵɵelementEnd();
        i0.ɵɵconditionalCreate(13, ChartOptionsComponent_Conditional_13_Template, 1, 4, "ycn-single-select-dropdown", 7);
        i0.ɵɵconditionalCreate(14, ChartOptionsComponent_Conditional_14_Template, 2, 4);
        i0.ɵɵelementEnd()();
        i0.ɵɵelement(15, "ycn-help-modal", null, 1);
    } if (rf & 2) {
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(10, _c1, ctx.isOpen));
        i0.ɵɵadvance(5);
        i0.ɵɵtextInterpolate1(" ", ctx.chartOptionsConfig.title.label);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(12, _c1, ctx.isOpen));
        i0.ɵɵadvance();
        i0.ɵɵrepeater(ctx.chartOptionsConfig.list);
        i0.ɵɵadvance(3);
        i0.ɵɵconditional(ctx.dataInFooterDropdownConfig && ctx.dataInFooterDropdownConfig.list.length ? 10 : -1);
        i0.ɵɵadvance();
        i0.ɵɵconditional(ctx.dataInLegendDropdownConfig ? 11 : -1);
        i0.ɵɵadvance();
        i0.ɵɵproperty("customCssClasses", i0.ɵɵpureFunction0(14, _c2))("customLabel", "Name in Legend")("config", ctx.nameInLegendOptionsConfig);
        i0.ɵɵadvance();
        i0.ɵɵconditional(ctx.valueFlagsDropdownConfig ? 13 : -1);
        i0.ɵɵadvance();
        i0.ɵɵconditional(ctx.frequencyOptionsConfig ? 14 : -1);
    } }, dependencies: [i2.NgClass, i3.CheckboxControlValueAccessor, i3.NgControlStatus, i3.NgModel, i4.HelpModalComponent, i5.MultiSelectDropdownComponent, i6.SingleSelectDropdownComponent], encapsulation: 2 });
